const responseToJson = (response) => {
  return response.json()
};

export default responseToJson;
